<ng-container [formGroup]="parent">
    <table mat-table [dataSource]="addends" class="percentage-table">
      <caption class="visually-hidden">Percentage Table</caption>

      <ng-container matColumnDef="allocees">
        <label for="allocees-to" class="visually-hidden">To</label>
        <th id="allocees-allocees" mat-header-cell *matHeaderCellDef> To: </th>
        <td mat-cell *matCellDef="let addend"> {{ addend.QuestionText }} </td>
        <td mat-footer-cell *matFooterCellDef> Total&nbsp; <sup class="asterisk">*</sup></td>
      </ng-container>
  
      <ng-container matColumnDef="percentages">
        <label for="allocees-percentages" class="visually-hidden">Percentages</label>
        <th id="allocees-percentages" mat-header-cell *matHeaderCellDef>
          <ng-container >Percent:</ng-container>
        </th>
        <td mat-cell *matCellDef="let addend">
          <div class="input-group">
            <input (keyup)="getTotal($event)" [cleave]="mask" [maxlength]="maxLength" class="form-control" [formControlName]="addend.QuestionName" [id]="addend.QuestionName" [type]="addend.inputType" tabindex="0" [ngClass]="{'input-required': isRequired && isEditable, 'disabled': !isEditable}">
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
    </table>
  </ng-container>
  <ng-container><hr style="margin-top:50px;margin-bottom:-30px;" /></ng-container>